var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.currentAccount
    ? _c("div", { staticClass: "row roomy" }, [
        _c(
          "div",
          {
            staticClass:
              "margin-auto margin-bottom-4xl laptop:margin-right-0 laptop:margin-bottom-0",
          },
          [
            _c(
              "commission-card",
              {
                attrs: {
                  cost: 300,
                  "icon-count": 1,
                  theme: _vm.theme,
                  avatar: "faSquare",
                  description:
                    "Add that single icon you've always wanted in all of Font Awesome's styles.",
                  type: "icon",
                },
              },
              [
                _c(
                  "footer",
                  {
                    staticClass: "section text-left",
                    attrs: { slot: "footer" },
                    slot: "footer",
                  },
                  [
                    _c("dl", { staticClass: "padding-0 margin-0 size-sm" }, [
                      _c("dt", [_vm._v("Order ID:")]),
                      _vm._v(" "),
                      _c("dd", [_vm._v(_vm._s(_vm.currentOrder.number))]),
                      _vm._v(" "),
                      _c("dt", { staticClass: "sr-only" }, [
                        _vm._v("Email associated with subscription"),
                      ]),
                      _vm._v(" "),
                      _c("dd", [_vm._v(_vm._s(_vm.currentAccount.email))]),
                    ]),
                  ]
                ),
              ]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "column-12 laptop:column laptop:margin-left-4xl" },
          [
            _c("div", { staticClass: "margin-bottom-4xl" }, [
              _c(
                "h1",
                { staticClass: "margin-top-0 laptop:margin-bottom-md" },
                [_vm._v(_vm._s(_vm.selectedSalutation))]
              ),
              _vm._v(" "),
              _c("p", { staticClass: "size-lg line-length-md" }, [
                _vm._v(
                  "You've commissioned 1 icon to be added to Font Awesome."
                ),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "ol",
              {
                staticStyle: {
                  "--list-style-type": "none",
                  "--padding-left": "0",
                },
              },
              [
                _c(
                  "success-next-step",
                  {
                    attrs: {
                      title: "Your Commission Adds a New Icon!",
                      "icon-name": "faIcons",
                    },
                  },
                  [
                    _c("p", [
                      _vm._v(
                        "We'll add the icon you want across our 5 classic and 5 new sharp styles all of which will be released in Font Awesome."
                      ),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "success-next-step",
                  {
                    attrs: {
                      title: "We'll Be In Touch About Next Steps",
                      "icon-name": "faHandshake",
                    },
                  },
                  [
                    _c("p", [
                      _vm._v(
                        "\n          We'll reach out to you via email shortly. We'll ask you some pointed questions about the icon you want to sponsor and take your original request as\n          inspiration as we design. You'll be able to check it out before we ship that fresh icon in Font Awesome Pro. If you have any questions about the\n          processing,\n          "
                      ),
                      _c(
                        "a",
                        {
                          attrs: {
                            href: "mailto:icons@fontawesome.com?subject=I commissioned an icon and have a question",
                          },
                        },
                        [_vm._v("get in touch")]
                      ),
                      _vm._v("\n          .\n        "),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _vm.accessToPro
                  ? _c(
                      "success-next-step",
                      {
                        attrs: {
                          title:
                            "Font Awesome - Now Including Your Commission ",
                          "icon-name": "faRocketLaunch",
                        },
                      },
                      [
                        _c("p", [
                          _vm._v(
                            "\n          Your commissioned icon will be part of Font Awesome's Pro icons. And your current Pro-level subscription will give you access to use these icons\n          once they're ready and released as part of Font Awesome.\n        "
                          ),
                        ]),
                      ]
                    )
                  : _c(
                      "success-next-step",
                      {
                        attrs: {
                          "has-secondary-action": "",
                          title:
                            "Get a Pro Subscription to Use Your Commission in Font Awesome",
                          "icon-name": "faRocketLaunch",
                        },
                      },
                      [
                        _c("p", [
                          _vm._v(
                            "\n          Your commissioned icon will be part of Font Awesome's Pro icons.\n          "
                          ),
                          _c("strong", [
                            _vm._v(
                              "In order to use it when it's released, you'll need an active subscription."
                            ),
                          ]),
                          _vm._v("\n          .\n        "),
                        ]),
                        _vm._v(" "),
                        _c(
                          "site-link",
                          {
                            staticClass:
                              "button tablet:display-block laptop:display-inline-block",
                            attrs: {
                              slot: "action-primary",
                              to: { name: `plans` },
                            },
                            slot: "action-primary",
                          },
                          [_vm._v("\n          Get a Pro Plan\n        ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "site-link",
                          {
                            staticClass: "display-block text-center",
                            attrs: {
                              slot: "action-secondary",
                              to: { name: `home` },
                            },
                            slot: "action-secondary",
                          },
                          [
                            _vm._v(
                              "\n          Check out all of Font Awesome\n        "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
              ],
              1
            ),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }